// src/pages/Auth/SetUsername.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUsernameThunk } from "../../redux/features/Auth/authThunk";
import { Loader2, User, ArrowLeft } from "lucide-react";

const SetUsername = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, userInfo } = useSelector((state) => state.auth);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  // اگر کاربر جدید نباشد، به خانه برود
  if (!userInfo?.access) {
    navigate("/phone");
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!firstName.trim()) {
      alert("نام الزامی است.");
      return;
    }
    dispatch(setUsernameThunk({ first_name: firstName, last_name: lastName })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        navigate("/");
      }
    });
  };

  return (
    <div className="min-h-screen bg-[#F0F4EB] flex items-center justify-center py-8 px-4" dir="rtl">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#DCE4D3]">
          <div className="relative bg-gradient-to-l from-[#8A9A7B] to-[#9EAD8C] px-6 py-8 text-white">
            <button
              onClick={() => navigate(-1)}
              className="absolute top-4 right-4 p-2 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <User className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-2xl font-bold">خوش آمدید 👋</h1>
              <p className="text-white/80 text-sm mt-1">
                لطفاً نام خود را وارد کنید
              </p>
            </div>
          </div>

          <div className="p-6">
            <form onSubmit={handleSubmit}>
              <div className="relative mb-4">
                <User className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="نام"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full pr-11 pl-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:border-[#8A9A7B] outline-none transition-all"
                  required
                />
              </div>
              <div className="relative mb-4">
                <User className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="نام خانوادگی (اختیاری)"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full pr-11 pl-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:border-[#8A9A7B] outline-none transition-all"
                />
              </div>
              {error && (
                <p className="text-red-500 text-sm mb-4 flex items-center gap-1">
                  <span className="inline-block w-1 h-1 bg-red-500 rounded-full" />
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3.5 bg-[#8A9A7B] text-white rounded-xl font-bold hover:bg-[#6A7A5B] transition-all disabled:opacity-50 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    در حال ثبت...
                  </>
                ) : (
                  "تکمیل ثبت‌نام"
                )}
              </button>
            </form>

            <div className="mt-6 pt-4 border-t border-gray-100 text-center text-xs text-gray-400">
              <p>این نام در فروشگاه نمایش داده خواهد شد.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetUsername;